import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import telematicsService from "../../../api/telematics.service";
export default {
  name: 'servicemapping',
  components: {pageheader},
  data () {
    return {
      input: {},
      search: "",
      serviceMappingsList: [],
      templatesList: [],
      isTemplate: false,
      isServiceMapping: false,
      selectedTemplate: "",
      expanded: [],
      isUnlink: false,
      headers: [
        { text: "#", value: "sno"},
        { text: "Template Name", value: "templateName"},
      ],
      subHeaders: [
        { text: "#", value: "sno"},
        { text: "Template", value: "templateName" },
        {text:"Customer", value: "customer"},
        {text:"Trigger", value: "triggerValue"},
        {text:"Category", value: "category"},
        {text:"Stock Key", value: "stockKey"},
        {text:"Actions", value: "actions"}
      ]
    }
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted () {
    this.input = utils.getInputContent("servicetemplatemapping", this.roles);
    this.getServiceTemplatesList();
    this.getServiceMappings();
  },
  filters: {
    numberFormat: function(value){
      if(value != 'Quarterly' || value != 'Monthly' || value != 'yearly'){
        return Number(value).toLocaleString();
      }
    }
  },
  methods: {
    mapNewServiceTemplate(){
      this.$router.push({name: 'Map New Service Template'});
    },
    async getServiceTemplatesList(){
      this.isTemplate = true;
      let templateId = "";
      try{
      let response = await telematicsService.getScheduledServices(templateId);
      if(response.isSuccess){
        this.isTemplate = false;
        this.templatesList = response.data;
      }else{
        this.isTemplate = false;
        this.serviceMappingsList = [];
      }
    }catch(err){
      this.isTemplate = false;
      console.log(err);
    }
    },
    async getServiceMappings(){
      this.isServiceMapping = true;
      let templateId = "";
      if(this.selectedTemplate){
        templateId = this.selectedTemplate;
      }else{
        templateId = "";
      }
      try{
      let response = await telematicsService.getScheduledServices(templateId);
      if(response.isSuccess){
        this.isServiceMapping = false;
        this.serviceMappingsList = response.data.map((d, index) => ({
          ...d,
          sno: index + 1,
        }));
        for(var i =0; i<this.serviceMappingsList.length;i++){
          if(this.serviceMappingsList[i].serviceDetails.length>0){
            this.serviceMappingsList[i].serviceDetails = this.serviceMappingsList[i].serviceDetails.map((d, index) => ({
              ...d,
              sno: index + 1,
            }));
          }
        }
      }else{
        this.isServiceMapping = false;
        this.serviceMappingsList = [];
      }
    }catch(err){
      this.isServiceMapping = false;
      console.log(err);
    }
    },
    clearFilters(){
      this.selectedTemplate = "";
      this.getServiceMappings();
    },
    clickRow(item, event) {
      if (event.isExpanded) {
        const index = this.expanded.findIndex((i) => i === item);
        this.expanded.splice(index, 1);
      } else {
        this.expanded.push(item);
      }
    },
    expandAll(){
      this.$data.expanded = this.$data.serviceMappingsList;
    },
    collapseAll() {
      this.$data.expanded = [];
    },
    async unlinkServiceRecord(item){
      this.isUnlink = true;
      try{
        let response = await telematicsService.unlinkServiceRecord(item.templateId,item.equipmentId);
        if(response.isSuccess){
          this.isUnlink = false;
          this.$toast.success(response.systemMessage);
          this.getServiceMappings();
        }else{
          this.isUnlink = false;
          this.$toast.error(response.systemMessage);
        }
      }catch(err){
        this.isUnlink = false;
        console.log(err);
      }
    }
  }
}


